export default {
  namespaced: true,
  teams: {
    title: "Area",
    name: "Nombre",
    description: " Descripción",
  },
};
